import axios from "axios";
import { API_URL } from "../../constants/config";

export const uploadProfileImage = async (accessToken, formData) => {
    let url = `${API_URL}api/v1/learner_upload_image`;

    try {
        const response = await axios.post(url, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
            Authorization: null,
            "Access-Token": `${accessToken}`,
        },
        });

        return response.data;
    } catch (error) {
        console.error("Error:", error);
        return false;
    }
};

export const uploadBannerImage = async (accessToken, formData) => {
    let url = `${API_URL}api/v1/learner_upload_banner_image`;

    try {
        const response = await axios.post(url, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
            Authorization: null,
            "Access-Token": `${accessToken}`,
        },
        });

        return response.data;
    } catch (error) {
        console.error("Error:", error);
        return false;
    }
};
